// sendMeNotificationsRead.js
'use strict';
import fetch from '../resource/customFetch.js';

import getMeData from '../selector/getMeData.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import handleFetchError from '../resource/handleFetchError.js';

import {
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';

/**
 * Send me notification read
 * @kind action
 * @param {[string]} {notificationIds} - set notification read ids.
 * @return {Promise} Action promise.
 */
const sendMeNotificationsRead =
  ({ notificationIds }) =>
  async (dispatch, getState) => {
    const selectPath = ['notification', 'me'];
    const token = getMeData(getState(), 'token');

    if (!token || !notificationIds?.length) {
      return dispatch({ type: '' });
    }

    const fetchOptions = {
      method: 'PUT',
      headers: {
        ...getHeaders(),
        Authorization: `Bearer ${token}`,
      },
    };

    const url = getResourceUrl({ endpoint: '/me/notification' });
    notificationIds.forEach(id => {
      url.searchParams.append('id', id);
    });

    dispatch({ type: SET_NETWORKING_FETCHING, payload: { selectPath } });
    try {
      let response = await fetch(url.href, fetchOptions);

      if (!response.ok) {
        response = await handleFetchError({
          response,
          dispatch,
          getState,
          fetchOptions,
          fetchUrl: url,
        });
      }

      return dispatch({
        type: SET_NETWORKING_SUCCESS,
        payload: { selectPath },
      });
    } catch (error) {
      return dispatch({
        type: SET_NETWORKING_ERROR,
        payload: { selectPath, error },
      });
    }
  };

export default sendMeNotificationsRead;
